<template>
  <div>
    <label :for="uid" class="flex items-center gap-x-2 text-sm font-medium leading-6 text-gray-900">
      {{ label }}
      <slot name="label-color" />
    </label>
    <div class="mt-1 relative">
      <div class="flex gap-2">
        <input
          :id="uid"
          v-model="newTag"
          :placeholder="placeholder || 'Enter tag and press Enter'"
          :readonly="readonly"
          class="block w-full rounded-md border-0 py-1.5
            text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 
            placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
          :class="{'ring-red-500': errorMsg}"
          @keyup.enter="addTag"
        >
        <button
          :disabled="readonly || !newTag.trim()"
          class="rounded-md bg-primary-600 px-3 py-2
              text-sm font-semibold text-white shadow-sm hover:bg-primary-500
              focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 disabled:opacity-50"
          @click="addTag"
        >
          Add
        </button>
      </div>
      <div v-show="errorMsg" class="absolute text-xs text-red-500 mt-0.5">
        {{ errorMsg }}
      </div>
      <draggable v-model="model" tag="div" class="mt-2 flex flex-wrap gap-2" item-key="(tag) => tag">
        <template #item="{ element: tag }">
          <span class="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-800 cursor-move">
            {{ tag }}
            <button
              v-if="!readonly"
              class="ml-1 inline-flex items-center justify-center w-4 h-4 rounded-full text-gray-400 hover:bg-gray-200 hover:text-gray-500"
              @click="removeTag(tag)"
            >
              ×
            </button>
          </span>
        </template>
      </draggable>
    </div>
  </div>
</template>

<script setup>
import { ref, useId } from 'vue';
import draggable from 'vuedraggable';

defineProps({
  label: {
    type: String,
    default: null
  },
  placeholder: {
    type: String,
    default: null
  },
  errorMsg: {
    type: String,
    default: ''
  },
  readonly: {
    type: Boolean,
    default: false
  }
});

const uid = useId();
const newTag = ref('');

const model = defineModel({
  type: Array,
  default: () => []
});

function addTag() {
  if (newTag.value.trim()) {
    model.value.push(newTag.value.trim());
    newTag.value = '';
  }
}

function removeTag(tag) {
  model.value = model.value.filter(t => t !== tag);
}
</script>
